import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const line = (values) => {
  const daterange = values && values.daterange ? String(values.daterange) : "";
  const dates = daterange ? daterange.split(" - ") : [];
  const label = dates.length === 2 && dates[0] === dates[1]
    ? "Today"
    : (values && values.label) || "Today";
  const data = { label };
  if (daterange) data.daterange = daterange;
  if (values && values.staff_id !== undefined && values.staff_id !== null && values.staff_id !== "") {
    data.staff_id = values.staff_id;
  }
  const action = `afterlogin/chart/line`;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const chartApiController = {
  line,
};
export default chartApiController;
